export default import.meta.ROLLDOWN_FILE_URL_suDUd_2CvH2KHOEKRz$qUw